import AdxTabsBadge from 'components/reusable/tab/AdxTabsBadge'
import AdxTabsPanel from 'components/reusable/tab/AdxTabsPanel'
import React from 'react'
import { useLocation } from 'react-router-dom'
import EDDetailsTab from './EDDetailsTab'
import EDSortingTable from './EDSortingTable'

const EDTabs = ({
  appraisalStatus,
  title,
  description,
  formId,
  form,
  dept,
  rule,
  letRevieweeView,
  letReviewerView,
  letFeedback,
  letAnonymous,
  totalParticipants,
}) => {
  const { state } = useLocation()
  return (
    <AdxTabsBadge
      initialValue={state.evaluationTabsValue || 0}
      sxPanel={{
        marginTop: 3,
        // height: '60vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: 0,
          height: 0,
        },
        backgroundColor: 'transparent',
        borderRadius: 0,
      }}
      scrollButtons={false}
      tabsBorderBottom
    >
      <AdxTabsPanel label="Details">
        <EDDetailsTab
          description={description}
          formId={formId}
          form={form}
          dept={dept}
          rule={rule}
          letRevieweeView={letRevieweeView}
          letReviewerView={letReviewerView}
          letFeedback={letFeedback}
          letAnonymous={letAnonymous}
        />
      </AdxTabsPanel>
      <AdxTabsPanel notification={totalParticipants} label="Results">
        <EDSortingTable title={title} appraisalStatus={appraisalStatus} />
      </AdxTabsPanel>
    </AdxTabsBadge>
  )
}

export default EDTabs
